import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './configure'
import { AuthStateEnum } from '@vacationtracker/shared/types/auth-state'

interface AuthState {
  authState: AuthStateEnum
}

const initialState: AuthState = {
  authState: AuthStateEnum.signedOut,
}

export const authStateSlice = createSlice({
  name: 'authState',
  initialState,
  reducers: {
    setAuthState: (state, action: PayloadAction<AuthStateEnum>) => {
      state.authState = action.payload
    },
  },
})

export const { setAuthState } = authStateSlice.actions

export const selectAuthStateSlice = (state: RootState) => state.authStateSlice

/**
 * Nothing ever dispatches `signedOut`: it is the initial value above, so it means the session
 * check NextApp runs on mount has not answered yet. A stored user id says the answer is very
 * likely "signed in", which is what lets the sign-in and sign-up pages hold off drawing a form
 * the visitor would only see flash past on a hard load. Bounded either way, since that check
 * always resolves to `signedIn` or `signUp`, and neither is this.
 */
export const isSessionStillResolving = (authState: AuthStateEnum): boolean => authState === AuthStateEnum.signedOut && Boolean(localStorage.getItem('userId'))

export default authStateSlice.reducer
